<template>
  <div>
    <bubble-menu class="menububble" :editor="editor" v-if="editor">
      <button class="menububble__button" @click="editor.chain().focus().toggleBold().run()" :class="{ 'is-active': editor.isActive('bold') }">
        <i class="fa fa-bold" />
      </button>
      <button class="menububble__button" @click="editor.chain().focus().toggleItalic().run()" :class="{ 'is-active': editor.isActive('italic') }">
        <i class="fa fa-italic" />
      </button>
      <button class="menububble__button" @click="editor.chain().focus().toggleUnderline().run()" :class="{ 'is-active': editor.isActive('underline') }">
        <i class="fa fa-underline" />
      </button>
      <button class="menububble__button" @click="editor.chain().focus().toggleStrike().run()" :class="{ 'is-active': editor.isActive('strike') }">
        <i class="fa fa-strikethrough" />
      </button>
      <form class="menububble__form" v-if="linkMenuIsActive" @submit.prevent="setLinkUrl(linkUrl)">
        <input class="menububble__input" type="text" v-model="linkUrl" placeholder="https://" ref="linkInput" @keydown.esc="hideLinkMenu"/>
        <button class="menububble__button" @click="setLinkUrl(null)" type="button">
          <i class="fa fa-times" />
        </button>
      </form>

      <template v-else>
        <button
          class="menububble__button pt-0"
          @click="showLinkMenu(editor.getAttributes('link'))"
          :class="{ 'is-active': editor.isActive('link') }"
        >
          <span class="font-size-xSmall d-inline-block" style="margin-top: 1px; margin-right: 4px;">{{ editor.isActive('link') ? 'Mudar Link' : 'Criar Link'}}</span>
          <i class="fa fa-link" style="margin-top: 3px;" />
        </button>
      </template>
    </bubble-menu>
  </div>
</template>

<script>

import { BubbleMenu } from '@tiptap/vue-2'

export default {
  name: 'StylingMenu',
  props: ['editor', 'keepInBounds'],
  components: {
    BubbleMenu
  },
  data () {
    return {
      linkUrl: null,
      linkMenuIsActive: false
    }
  },
  methods: {
    hide () {
      this.hideLinkMenu()
    },
    hideLinkMenu () {
      this.linkUrl = null
      this.linkMenuIsActive = false
    },
    showLinkMenu (attrs) {
      this.linkUrl = attrs.href
      this.linkMenuIsActive = true
      this.$nextTick(() => {
        this.$refs.linkInput.focus()
      })
    },
    setLinkUrl (url) {
      if (url) this.editor.chain().focus().extendMarkRange('link').setLink({ href: url, target: '_blank' }).run()
      else this.editor.chain().focus().extendMarkRange('link').unsetLink().run()
      // command({ href: url })
      this.hideLinkMenu()
    }
  }
}
</script>

<style lang="scss" scoped>
/* BUBBLE MENU */
.menububble {
  display:-webkit-box;
  display:flex;
  z-index:20;
  background:#000;
  border-radius:5px;
  padding:.3rem;
  margin-bottom:.5rem;
  -webkit-transition:opacity .2s,visibility .2s;
  transition:opacity .2s,visibility .2s;
  font-size: $font_size_small;
}
.menububble__button {
  display:-webkit-inline-box;
  display:inline-flex;
  background:transparent;
  border:0;
  color:#fff;
  padding:.2rem .5rem;
  margin-right:.2rem;
  border-radius:3px;
  cursor:pointer;
  white-space: nowrap;
}
.menububble__button:last-child {
  margin-right:0
}
.menububble__button:hover {
  background-color:hsla(0,0%,100%,.1)
}
.menububble__button.is-active {
  background-color:hsla(0,0%,100%,.2)
}
.menububble__form {
  display:-webkit-box;
  display:flex;
  -webkit-box-align:center;
  align-items:center
}
.menububble__input {
  font:inherit;
  border:none;
  background:transparent;
  color:#fff
}
</style>
